import {Component, inject, signal} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";
import {MatAnchor, MatButton, MatIconButton} from "@angular/material/button";
import {MatCard} from "@angular/material/card";
import {MatFormField} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {ThemeToggleComponent} from "../settings/theme-toggle/theme-toggle.component";
import {Router, RouterLink} from "@angular/router";
import {RoomStore} from "../store/room.store";
import {LobbySettingsService} from "../shared/service/lobby-settings.service";
import {LobbyType} from "../../backend/state/lobby-state.model";
import {TranslateModule} from "@ngx-translate/core";
import {DailyStorageService} from "../daily/daily-storage.service";
import {ClickableCardDirective} from "../shared/directives/clickable-card.directive";
import {getGermanDateString} from "../daily/daily.util";

@Component({
  selector: 'app-home',
  imports: [
    MatIcon,
    MatButton,
    MatAnchor,
    MatIconButton,
    MatCard,
    MatFormField,
    MatInput,
    FormsModule,
    ThemeToggleComponent,
    RouterLink,
    TranslateModule,
    ClickableCardDirective
  ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent {
  private readonly roomStore = inject(RoomStore);
  private readonly dailyStorage = inject(DailyStorageService);

  lobbyId = signal('');

  creating = signal(false);

  dailyFinished = signal(this.dailyStorage.getProgress(getGermanDateString()).finished);

  dailyStreak = signal(this.dailyStorage.getCurrentStreak());

  constructor(private lobbySettingsService: LobbySettingsService,
              private router: Router) {
    this.roomStore.leaveRoom();
  }

  async createLobby() {
    this.creating.set(true);
    try {
      const settings = this.lobbySettingsService.getPersistedSettings();
      const room = await this.roomStore.createRoom(LobbyType.TEAMS, settings);
      this.router.navigate(['lobby', room.roomId]);
    } finally {
      this.creating.set(false);
    }
  }

  joinLobby() {
    // players might paste the whole invite link instead of the lobby id
    const input = this.lobbyId().trim();
    const id = input.match(/\/(?:lobby|host)\/([^/?#]+)/)?.[1] ?? input;
    if (id) {
      this.router.navigate(['lobby', id]);
    }
  }
}
